<template>
  <div class="py-[120px] xl:py-[140px]">
    <img
      src="/landing/images/plan-cover.webp"
      alt="Plan Cover"
      class="absolute left-0 top-0 w-full h-auto xl:block hidden"
    />
    <div class="container">
      <div class="relative">
        <SectionTitle
          :title="$t('landing.pricing.title')"
          class="mx-auto text-center"
        />
        <CTabFull
          active-items-class="!text-dark-300"
          v-model="currentPlan"
          :list="plansList"
        />
      </div>
      <Transition name="fade" mode="out-in">
        <div
          :key="currentPlan"
          class="w-full items-stretch grid md:grid-cols-2 xl:grid-cols-4 gap-6 md:gap-4"
        >
          <CardPlan
            v-for="(card, index) in plans"
            v-bind="{ card, index }"
            :is-current-tab="currentPlan"
            :key="index"
          />
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import CTabFull from "@/components/Common/Tab/CTabFull.vue";

import SectionTitle from "@/modules/Landing/components/Common/SectionTitle.vue";
import CardPlan from "@/modules/Landing/components/Card/Plan.vue";
import { useHead } from "@vueuse/head";
import ApiService from "@/services/ApiService";
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";

const plans = ref([]);
const currentPlan = ref("monthly");
const { t } = useI18n();
const loading = ref(true);

const plansList = ref([
  {
    label: t("monthly"),
    value: "monthly",
  },
  {
    label: t("annually"),
    value: "yearly",
  },
]);
function getList() {
  loading.value = true;
  ApiService.get("/payment/plans/")
    .then((res: any) => {
      plans.value = res?.data?.results;
    })
    .finally(() => (loading.value = false));
}
onMounted(() => {
  getList();
});

useHead({
  title: "Find the Plan That Powers Your Goals | Saraf Robot",
  meta: [
    {
      name: "description",
      content: "Powerful tool to enhance your crypto trading experience.",
    },

    // Open Graph (OG) meta tags
    {
      property: "og:title",
      content: "Find the Plan That Powers Your Goals | Saraf Robot",
    },
    {
      property: "og:description",
      content: "Powerful tool to enhance your crypto trading experience.",
    },
    { property: "og:image", content: "/og-image.webp" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:width", content: "1200" },

    // Twitter meta tags
    { name: "twitter:card", content: "summary" },
    { name: "twitter:site", content: "@sarafrobot" },
    { name: "twitter:image", content: "/og-image.webp" },
  ],
  link: [{ rel: "canonical", href: "https://app.sarafrobot.com/pricing" }],
});
</script>

<style scoped></style>
